import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useCallback } from 'react'

export const useDeleteTaxRegistration = () => {
  const deleteTaxRegistration = useCallback(async (id: string) => {
    const response = await dashboard20240730Client
      .deleteTaxRegistration({ id })
      .then(result => {
        if (result?.error) return null
        return result?.data
      })
    return response
  }, [])

  return { deleteTaxRegistration }
}
